import { render, staticRenderFns } from "./dealerLogTj.vue?vue&type=template&id=a395cbd6&scoped=true"
import script from "./dealerLogTj.vue?vue&type=script&lang=js"
export * from "./dealerLogTj.vue?vue&type=script&lang=js"
import style0 from "./dealerLogTj.vue?vue&type=style&index=0&id=a395cbd6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a395cbd6",
  null
  
)

export default component.exports